

export const devLogs = [
  {
    id: "coldflare-is-online",
    title: "Dev Log #1 — ColdFlare Studios Is Online",
    date: "July 9, 2026",
    excerpt:
      "The first official ColdFlare Studios dev log. Neon Lanes is moving toward public release, and the studio website is becoming the home for future games, updates, and experiments.",
    content: `
Welcome to the first official ColdFlare Studios dev log.

This is the beginning of a bigger journey. ColdFlare Studios started as a solo game development project, but it is slowly becoming a real creative home for my games, experiments, updates, and future projects.

The first major release from ColdFlare Studios is Neon Lanes, an endless lane-shifting arcade game built in Unity. Neon Lanes began as a learning project, but it has grown into the first real public step for the studio. It has already gone through Android testing, received feedback, and gone through several improvements along the way.

The latest update improves the menu readability, fixes issues across web and Android builds, and helps make the game feel more ready for public release. Neon Lanes will be available through the ColdFlare itch.io page and my personal website while I continue building out the full studio presence.

This website will also become the home for future dev logs, small browser games, prototypes, and updates on what I am building next. Some projects will be polished releases. Others may be experiments, game jam ideas, or early prototypes. The goal is to keep creating, keep learning, and keep sharing the process.

For now, the focus is simple:

Keep improving Neon Lanes.
Release playable games.
Build the ColdFlare Studios community one step at a time.

Thanks for stopping by at the start of the journey.

— Jason Jacobs
ColdFlare Studios
    `,
  },
 
];
